import api from "../../../api";

export function allTags(){
    return api.get("getAllTags");
}

export function deleteTags(id){
    return api.delete(`deleteMastertag/${id}`);
}

export function addTag(payload){
   return api.post("addMasterTag", payload);
}